import { FolderDetailsDataStoreFactory } from './folderDetailsDataStore';
import { LibraryDataStore } from './libraryDataStore';
import { RecentDocumentsDataStoreFactory } from './recentDocumentsDataStore';
import { SearchDataStoreFactory } from './searchDataStore';
import { SelectionDataStoreFactory } from './selectionDataStore';
import { SharedContentDataStoreFactory } from './sharedContentDataStore';
import { TagDataStoreFactory } from './tagDataStore';
import { DocumentDataStore } from './documentDataStore';
import { ViewItemIndexDataStoreFactory } from './viewItemIndexDataStore';
import { DeletedItemsDataStore } from './deletedItemsDataStore';
import { DocumentDetailsDataStoreFactory } from './documentDetailsDataStore';
import { FolderDataStore } from './folderDataStore';
import { DownloadDataStore } from './downloadDataStore';
import { NotificationDataStore } from './notificationDataStore';
import { InProgressItemsDataStore  } from './inProgressItemsDataStore';
import { UploadProgressDataStore } from './uploadProgressDataStore';
import { FavoritesDataStore } from './favoritesDataStore';
import { TasksDataStore } from './tasksDataStore'

export const datastoreModule = angular
	.module('sharebase-app.datastore',[
		'sharebase'
	])
	.factory('sbaFolderDetailsDataStore', FolderDetailsDataStoreFactory)
	.service('sbaLibraryDataStore', LibraryDataStore)
	.factory('sbaRecentDocumentsDataStore', RecentDocumentsDataStoreFactory)
	.factory('sbaSearchDataStore', SearchDataStoreFactory)
	.factory('sbaSelectionDataStore', SelectionDataStoreFactory)
	.factory('sbaSharedContentDataStore', SharedContentDataStoreFactory)
	.factory('sbaTagDataStore', TagDataStoreFactory)
	.factory('sbaViewItemIndexDataStore', ViewItemIndexDataStoreFactory)
	.service('sbaDeletedItemsDataStore', DeletedItemsDataStore)
	.factory('sbaDocumentDetailsDataStore', DocumentDetailsDataStoreFactory)
	.service('pxUploadProgressDataStore', UploadProgressDataStore)
	.service('sbaDocumentDataStore', DocumentDataStore)
	.service('sbaDownloadDataStore', DownloadDataStore)
	.service('sbaFolderDataStore', FolderDataStore)
	.service('sbaFavoritesDataStore', FavoritesDataStore)
	.service('sbaInProgressItemsDataStore', InProgressItemsDataStore)
	.service('sbaNotificationDataStore', NotificationDataStore)
	.service('sbaTasksDataStore', TasksDataStore);


// WEBPACK FOOTER //
// ./src/sharebase-app/dataStores/index.ts